export const FIELD_INVESTMENT_STRATEGY = "investmentStrategy";
